module.exports = __webpack_public_path__ + "img/intro2.2586c1ed.svg";